export default __webpack_public_path__ + "static/media/pencilRIght.9a158cda.png";